export default "__VITE_ASSET__CNBwMSOs__"